import { render, staticRenderFns } from "./Trade.vue?vue&type=template&id=57396851&scoped=true"
import script from "./Trade.vue?vue&type=script&lang=js"
export * from "./Trade.vue?vue&type=script&lang=js"
import style0 from "./Trade.vue?vue&type=style&index=0&id=57396851&prod&scoped=true&lang=css"
import style1 from "./Trade.vue?vue&type=style&index=1&id=57396851&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57396851",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VLayout})
